import { Settings } from "@mui/icons-material";
import { Button } from "@mui/material";
import { PageTitle } from "pages/common";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { closeLoader, showLoader } from "reducers";
import { parametrageService } from "services";
import { ParametrageResource } from "types";
import { CODE_PARAMETRAGE } from "utils/constant";
import SettingGlobalDetail from "./SettingGloablDetail";
import { SettingGlobalForm } from "./SettingGlobalForm";
import { setGlobalSetting } from "reducers/menu";

const SettingGlobal = () => {
  const [parametrage, setParametrage] = useState<
    ParametrageResource | undefined
  >();
  const [showForm, setShowForm] = useState<boolean>(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(showLoader());
    parametrageService
      .findAll({
        code: CODE_PARAMETRAGE.parametre_global,
      })
      .then(({ data }) => {
        setParametrage(data[0] || ({} as ParametrageResource));
      })
      .finally(() => {
        dispatch(closeLoader());
      });
  }, [dispatch]);

  const save = (data: Record<string, any>) => {
    if (parametrage?.id) {
      return parametrageService.update(parametrage.id, {
        value: data,
      });
    }
    return parametrageService.create({
      value: data,
      code: CODE_PARAMETRAGE.transport_facture,
    });
  };

  if (!parametrage) {
    return null;
  }

  if (showForm) {
    return (
      <SettingGlobalForm
        onBack={setShowForm.bind(this, false)}
        defaultValues={{ ...parametrage.value }}
        onSave={save}
        onFinished={(data: any) => {
          setParametrage(data);
          dispatch(setGlobalSetting(data));
          setShowForm(false);
        }}
      />
    );
  }

  return (
    <>
      <PageTitle
        title="Paramètre global"
        subtitle="Définir les paramètres globaux à l'application"
        TitleIcon={Settings}
        right={
          <Button
            onClick={setShowForm.bind(this, true)}
            color="error"
            variant="contained"
            sx={{ marginRight: 1 }}
          >
            Modifier
          </Button>
        }
      />

      <SettingGlobalDetail parametrage={parametrage} />
    </>
  );
};

export default SettingGlobal;
